import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/utility/services/common/common-service.service';
import { IFileExtend } from 'src/app/feature-module/product/model/IFileExtend';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BancaOnlineSubmissionService extends CommonService {
  constructor(http: HttpClient) {
    super('/api/banca-online-submission', http);
  }

  getBancaGroupPolicyNumbers(): Observable<any> {
    return this.http.get(this.routePrefix + '/getBancaGroupPolicyNumbersForAutocomplete/');

  }

  getEnrolsByBancaGroupPolicyId(groupPolicyId: number, searchText: string): Observable<any> {

    const param = new HttpParams()
      .set("groupPolicyId", groupPolicyId.toString())
      .set("searchText", searchText);

    return this.http.get(this.routePrefix + "/getEnrolsByBancaGroupPolicyId", { params: param });
    //return this.http.get(this.routePrefix + '/getEnrolsByBancaGroupPolicyId/' + groupPolicyId);

  }

  GetAllActiveBancassurance(): Observable<any> {
    return this.http.get(this.routePrefix + '/active-bancassurances/');

  }

  getPatientListByGroupPolicyId(enrolId: number): Observable<any> {
    return this.http.get(this.routePrefix + '/getPatientListByEnrolId/' + enrolId);

  }

  getAllBancassuranceProduct(): Observable<any> {
    return this.http.get(this.routePrefix + '/getAllBancassuranceProduct/');

  }

  claimSubmission(data): Observable<any> {
    return this.http.post(this.routePrefix + "/add", data);
  }

  getBancaSubmissionRequiredDocuments(): Observable<IFileExtend[]> {
    return this.http.get<IFileExtend[]>(`${this.routePrefix}/requiredDocuments`);
  }

  getDocumentBasedOnIncident(): Observable<any> {
    return this.http.get<any>(`${this.routePrefix}/document-based-on-incident`);
  }

  getBancaClaimFormDocument(claimTypePrefix: string): Observable<IFileExtend> {
    return this.http.get<IFileExtend>(`${this.routePrefix}/getBancaClaimFormDocument/${claimTypePrefix}`);
  }

  getBancaClaimForm(data: any): Observable<any> {
    return this.http.post(this.routePrefix + '/getBancaClaimForm', data, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getHistoricalBancaNigoClaims(groupPolicyId: number): Observable<any> {
    return this.http.get(this.routePrefix + '/getHistoricalBancaNigoClaims/' + groupPolicyId);
  }

  getBancaGroupPoliciesForHR(policyType: number): Observable<any> {
    return this.http.get(`${this.routePrefix}/getBancaGroupPoliciesForHR/${policyType}`);
  }

  getBancaRequireNigoDocuments(bundleClaimId: number): Observable<any> {
    return this.http.get(`${this.routePrefix}/getBancaRequireNigoDocuments/${bundleClaimId}`);
  }

  additionalDocumentSubmission(data): Observable<any> {
    return this.http.post(this.routePrefix + "/additionalDocumentSubmission", data);
  }

}

